import {
  BookHistoryDateCriteria,
  BookStatusCode,
  FILTER_KEY_PERIOD,
  FILTER_KEY_SORT,
} from "@/types";
import dayjs from "dayjs";

export interface BookInfoRequest {
  bookStatusCode: string;
  sort: string;
  dateCriteria: BookHistoryDateCriteria;
  fromDate: string;
  toDate?: string;
}

export function useGetBookInfoRequest() {
  // 달력 화면을 위한 예약 내역 request 파라미터
  const requestForCalendar = (
    currentMonth: string,
    hasCancelStatus: boolean
  ) => {
    const bookStatusCode = hasCancelStatus
      ? `${BookStatusCode.END}, ${BookStatusCode.CANCEL}`
      : BookStatusCode.END;
    const fromDate = dayjs(currentMonth).startOf("month").format("YYYY-MM-DD");
    const toDate = dayjs(currentMonth).endOf("month").format("YYYY-MM-DD");
    const sort = "expectedOnDtm asc";
    const dateCriteria = BookHistoryDateCriteria.BOARD;

    return {
      bookStatusCode,
      fromDate,
      toDate,
      sort,
      dateCriteria,
    } as BookInfoRequest;
  };

  // 지난 예약 request 파라미터
  const requestForPastBook = (currentFilters: Map<string, string>) => {
    const bookStatusCode = `${BookStatusCode.END}, ${BookStatusCode.CANCEL}`;
    let fromDate = "";
    let toDate = "";

    const period = currentFilters.get(FILTER_KEY_PERIOD) ?? "1";
    if (period !== "전체") {
      fromDate = dayjs()
        .add(-Number(period.replace(/[^0-9]/g, "")), "month")
        .format("YYYY-MM-DD");
      toDate = dayjs().format("YYYY-MM-DD");
    }

    const order =
      currentFilters.get(FILTER_KEY_SORT) === "내림차순" ? "desc" : "asc";
    const sort = `expectedOnDtm ${order}, bookTs ${order}`;
    const dateCriteria = BookHistoryDateCriteria.BOOK;

    return {
      bookStatusCode,
      fromDate,
      toDate,
      sort,
      dateCriteria,
    } as BookInfoRequest;
  };

  // 다가오는 예약 request 파라미터
  const requestForUpcomingBook: BookInfoRequest = {
    bookStatusCode: BookStatusCode.END,
    dateCriteria: BookHistoryDateCriteria.BOARD,
    fromDate: dayjs().format("YYYY-MM-DD"),
    toDate: undefined,
    sort: "expectedOnDtm asc",
  };

  return {
    requestForCalendar,
    requestForPastBook,
    requestForUpcomingBook,
  };
}
